import * as dayjs from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import * as weekOfYear from 'dayjs/plugin/weekOfYear';
import * as minMax from 'dayjs/plugin/minMax';

dayjs.extend(customParseFormat);
dayjs.extend(weekOfYear);
dayjs.extend(minMax);

export default dayjs;
